import { BehaviorParameters } from 'rangeConfig/@types';
import { ComponentIds } from '@inter-ikea-core/core';
import { addFrontStyleToFrame, getFrontsInScene, getMajorityProduct } from '../utils/frontLayouts';
import { isSameFrontStyleApplied, setFrontStyleSheetVisible } from 'ducks/sheets';
import { isOpenFrame } from 'rangeConfig/platsa/rules/hideMenuRules';

import {
  addSlidingDoorFrontLayoutToFrame,
  alignedFramesHasSlidingDoor
} from '@inter-ikea-storageone/range-platsa';
import { ErrorMessages, ProductType } from '@inter-ikea-storageone/range';
import { hideNoFramesInSceneErrorMessage } from '../rules/hideMenuRules';
import addProduct from './addProduct';

const productTypesToSkipSheet = [
  ProductType.SMASTAD_BENCH,
  ProductType.SMASTAD_BENCH_WITH_DRAWER_ASM
];

const addProductWithFrontStyle = ({ coreApi, rootState, props, dispatch }: BehaviorParameters) => {
  const {
    products: { inMarket: products }
  } = rootState;

  const productToAdd = products.find(p => p.coreProductId === props.coreProductId);

  // Super hacky way to not show the sheet for certain products, but it works for now
  if (productToAdd && productTypesToSkipSheet.includes(productToAdd.type))
    return addProduct({ coreApi, rootState, props, dispatch });

  const isApplied = isSameFrontStyleApplied(rootState);

  const majorityProductId = getMajorityProduct(getFrontsInScene(coreApi));

  const placementResult = coreApi.products.add(props.coreProductId, props.position);
  if (!hideNoFramesInSceneErrorMessage(coreApi)) {
    coreApi.emit.onPlacementAttempt(ErrorMessages.NoFramesInScene);
  }
  coreApi.entities.disposeCollidingEntities(placementResult.errors);

  if (!placementResult.placedEntity) return placementResult;

  const frameToAdd = placementResult.placedEntity;

  const isFrameOpen = isOpenFrame(coreApi, frameToAdd.id);

  const alignedFramesHaveSlidingDoors = alignedFramesHasSlidingDoor(frameToAdd, coreApi);

  const frontsProduct = products.find(p => p.coreProductId === majorityProductId);

  if (!frontsProduct) return placementResult;

  const frontProductIsMostlySlidingDoors =
    frontsProduct.type === ProductType.PLATSA_SLIDING_DOOR_ASM ||
    frontsProduct.type === ProductType.PAX_SLIDING_DOOR_REGULAR_ASM ||
    frontsProduct.type === ProductType.PAX_SLIDING_DOOR_WITH_PANELS_ASM;

  const addFrontStyle = () => {
    if (frontsProduct && placementResult.placedEntity) {
      addFrontStyleToFrame(frontsProduct, placementResult.placedEntity, products, coreApi);
    }
  };

  const addSlidingDoorFrontStyle = () => {
    if (frontsProduct) {
      addSlidingDoorFrontLayoutToFrame(frontsProduct, frameToAdd, coreApi);
    }
  };

  const frames = coreApi.entities.getByComponent(ComponentIds.FRAME_COMPONENT_ID);

  if (frames.length >= 1 && !isFrameOpen) {
    if (isApplied) {
      if (alignedFramesHaveSlidingDoors && frontProductIsMostlySlidingDoors) {
        addSlidingDoorFrontStyle();
      } else addFrontStyle();
    } else if (isApplied === undefined) {
      dispatch(setFrontStyleSheetVisible(placementResult.placedEntity || undefined));
    }
  }

  return placementResult;
};

export { addProductWithFrontStyle };
